import React from 'react';
import { useTranslation } from 'react-i18next';
import { Eye } from 'lucide-react';

interface ViewLimitInputProps {
  viewLimit: number | null;
  onChange: (limit: number | null) => void;
}

export default function ViewLimitInput({ viewLimit, onChange }: ViewLimitInputProps) {
  const { t } = useTranslation('createNote');
  const [isLimited, setIsLimited] = React.useState(viewLimit !== null);

  const handleToggle = () => {
    setIsLimited(!isLimited);
    onChange(!isLimited ? 1 : null);
  };

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    onChange(value);
  };

  return (
    <label className="block text-sm font-medium text-gray-700">
      <div className="flex items-center mb-2">
        <Eye className="w-5 h-5 mr-2" />
        <span>{t('form.viewLimit.label')}</span>
      </div>
      <div className="flex items-center justify-between gap-4">
        <input
          type="range"
          value={viewLimit || 1}
          onChange={handleSliderChange}
          min={1}
          max={10}
          disabled={!isLimited}
          className="flex-grow h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500 disabled:opacity-50"
        />
        <button
          type="button"
          onClick={handleToggle}
          className="shrink-0 min-w-[5.5rem] text-center font-medium text-gray-700 bg-gray-100 px-3 py-1.5 rounded-lg hover:bg-gray-200 transition-colors"
        >
          {isLimited
            ? t('form.viewLimit.value', { count: viewLimit || 1 })
            : t('form.viewLimit.unlimited')}
        </button>
      </div>
      <p className="text-xs text-gray-500 mt-1">
        {isLimited
          ? t('form.viewLimit.limitedHint')
          : t('form.viewLimit.unlimitedHint')}
      </p>
    </label>
  );
}